import { render, staticRenderFns } from "./ApplianceKindInput.vue?vue&type=template&id=7354ed48&"
import script from "./ApplianceKindInput.vue?vue&type=script&lang=js&"
export * from "./ApplianceKindInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports